import axios from 'axios'

const LMS_USER_API_URL = '/api'
axios.defaults.withCredentials = true

export default {
  get () {
    return axios.get(LMS_USER_API_URL + '/cash')
  },
  get_overdue () {
    return axios.get(LMS_USER_API_URL + '/cash/overdue_amount')
  },
  get_online_payment_config () {
    return axios.get(LMS_USER_API_URL + '/cash/online_payment_config')
  }
}



// WEBPACK FOOTER //
// ./src/backend-resources/cash-resource.js